const getters = {
    incidentHeaders: (state) => state.incidents.headers
}

export default getters;